import React from 'react';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import FooterComponent from '../../../components/templates/Footer';

const Footer = props => (
  <FooterComponent
    {...pick(
      props,
      'pageData',
      'labels',
      'hideNavigation',
      'appHostPath',
      'userType',
      'contactSupportHref',
      'isEProcurementApp'
    )}
  />
);

export const mapStateToProps = state => ({
  pageData: get(state, ['global', 'globalData', 'pageData'], {}),
  labels: get(state, ['global', 'globalData', 'labels'], {}),
  appHostPath: get(state, ['global', 'globalData', 'config', 'appHostPath'], ''),
  userType: get(state, ['global', 'globalData', 'userDetails', 'userRole', 'role'], ''),
  contactSupportHref: get(state, ['global', 'globalData', 'config', 'contactSupportHref'], ''),
  isEProcurementApp: get(state, ['global', 'globalData', 'isEprocurementApp'], undefined),
});

export default connect(mapStateToProps)(Footer);

export { Footer };
